/**
 * Hebrew Calendar API integration using Hebcal.com
 * Documentation: https://www.hebcal.com/home/1705/yahrzeit-anniversary-api
 */

/**
 * Get the current Hebrew date
 * @returns {Promise<{hebrewDate: string, gregorianDate: string}>}
 */
export async function getCurrentHebrewDate() {
  try {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1; // JavaScript months are 0-indexed
    const day = today.getDate();

    // Use Hebcal's Hebrew date converter API
    // We'll use a simple approach: convert today's date to Hebrew
    const params = new URLSearchParams({
      cfg: 'json',
      v: 'yahrzeit',
      y1: year.toString(),
      m1: month.toString(),
      d1: day.toString(),
      t1: 'Birthday', // Just using this to get date conversion
      n1: 'Today',
      years: '1',
      hebdate: 'on',
    });

    const response = await fetch('https://www.hebcal.com/yahrzeit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: params.toString(),
    });

    if (!response.ok) {
      throw new Error(`Hebcal API error: ${response.status}`);
    }

    const data = await response.json();
    
    // Extract Hebrew date from the response
    // The API returns items with hdate field
    if (data.items && data.items.length > 0) {
      const firstItem = data.items[0];
      const hebrewDate = firstItem.hdate || '';
      
      // Format: "15 Cheshvan 5782" -> "15 Cheshvan"
      const parts = hebrewDate.split(' ');
      const hebrewDateShort = parts.slice(0, -1).join(' '); // Remove year
      
      return {
        hebrewDate: hebrewDateShort,
        fullHebrewDate: hebrewDate,
        gregorianDate: firstItem.date,
      };
    }

    // Fallback if no items returned
    return {
      hebrewDate: 'Error loading date',
      fullHebrewDate: '',
      gregorianDate: today.toISOString().split('T')[0],
    };
  } catch (error) {
    console.error('Error fetching Hebrew date:', error);
    // Return a fallback
    const today = new Date();
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const dayName = days[today.getDay()];
    return {
      hebrewDate: `${dayName}, ${today.getDate()} Shvat`, // Fallback
      fullHebrewDate: '',
      gregorianDate: today.toISOString().split('T')[0],
    };
  }
}

/**
 * Format Hebrew date for display
 * @param {string} hebrewDate - Hebrew date string from API
 * @returns {string} Formatted date string
 */
export function formatHebrewDate(hebrewDate) {
  if (!hebrewDate) return '';
  // Format: "15 Cheshvan" -> "15 Cheshvan"
  return hebrewDate;
}


